<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div style="padding:6px 15px; ">
			<Form ref="searchForm" :model="searchForm" label-position="left" :label-width="70" inline>
				<FormItem label="申请单号"><Input type="text" v-model="searchForm.orderid" placeholder="申请单号" /></FormItem>
				<FormItem label="会员手机"><Input type="text" v-model="searchForm.mobile" placeholder="手机号码" /></FormItem>
				<FormItem label="昵称"><Input type="text" v-model="searchForm.nickname" placeholder="昵称" /></FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('searchForm')">
						<Icon type="ios-search" />
						搜索
					</Button>
				</FormItem>
			</Form>
		</div>
		<Table :data="tableData2" :columns="tableColumns2" size="large" :loading="loading" header="header" footer="footer">
			<template slot-scope="{ row }" slot="user">
				<div class="flex">
					<div class=" padding-top-xs">
						<Avatar :src="'http://cjb.xahulian.com/'+ row.user.avatar " size="48" v-if="row.user.avatar" />
						<Avatar icon="ios-person" size="48" v-else />
					</div>
					<div class="padding-left-sm padding-top-xs text-left">
						<span class="text-lg">{{row.user.nickname}}</span><br />
						<span class="text-blue">{{row.user.mobile}}</span>
					</div>
				</div>
			</template>
			<template slot-scope="{ row }" slot="state">
				<Tag color="warning" v-if="row.stateflag=='0'">未处理</Tag> 
				<Tag color="primary" v-if="row.stateflag=='1'">处理中</Tag> 
				<Tag color="success" v-if="row.stateflag=='6'">已处理</Tag> 
				<Tag v-if="row.stateflag=='9'">已取消</Tag> 
			</template>
			<template slot-scope="{ row }" slot="action">
				<router-link tag="a" :to="{ path: 'view/'+row.id }">
					<Button type="primary">
						查看
					</Button>
				</router-link>
			</template>

			<template slot="header">
				<div class="flex justify-between">
					<div span="12">
					</div>
					<div span="12">
						<div style="text-align: right;">
							<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
							 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
						</div>
					</div>
				</div>

			</template>
			<template slot="footer">
				<div style="text-align: right;">
					<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
					 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
				</div>
			</template>
		</Table>
		<Modal v-model="modalModifyPass" title="修改密码" :footer-hide="true" :width="400">
			<div style="position: relative;">
				<Form ref="formModifyPass" :model="formModifyPass" label-position="right" :label-width="100" label-colon>
					<FormItem label="新密码">
						<Input v-model="formModifyPass.newpass" />
					</FormItem>
					<FormItem>
						<Button type="primary" @click="submitModifyPass('formModifyPass')" :loading="loadingModifyPass">提交</Button>
						<Button style="margin-left: 8px" @click="modalModifyPass=false">取消</Button>
					</FormItem>
				</Form>
				<Spin fix v-if="loadingModifyPass">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>处理中...</div>
				</Spin>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				jczList: [],
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						width: 58
					},
					{
						title: '单号',
						align: 'center',
						key: 'uid'
					},
					{
						title: '提现积分',
						key: 'score',
						align: 'center'
					},
					{
						title: '状态',
						slot: 'state',
						align: 'center'
					},
					{
						title: '会员',
						align: 'center',
						slot: 'user',
						width: 250
					},
					{
						title: '提交时间',
						key: 'addtime',
						align: 'center'
					},
					{
						title: '最后更新',
						key: 'updatetime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center'
					}
				],
				tableData2: [],
				searchForm: {
					page: 1,
					size: 20,
					total: 0,
					mobile: '',
					nickname: ''
				},
				modalModifyPass: false,
				loadingModifyPass: false,
				formModifyPass: {
					uid: '',
					newpass: ''
				}
			};
		},
		methods: {
			showModifyPass(uid) {
				this.formModifyPass.uid = uid;
				this.modalModifyPass = true;
			},
			submitModifyPass() {
				var that = this;
				this.loadingModifyPass = true;
				this.$http.post('/server/api/client/user/index.php?a=modifypass', this.$qs.stringify(this.formModifyPass)).then(
					res => {
						this.loadingModifyPass = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.modalModifyPass = false;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingModifyPass = false;
						this.$Message.error('系统错误');
					}
				);
			},
			handleSubmit(name) {
				this.loadinfos();
				return false;
			},
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/client/tx/index.php?a=list', this.$qs.stringify(this.searchForm)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.searchForm.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			pageChange(page) {
				this.searchForm.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.searchForm.size = size;
				this.loadinfos();
			}
		},
		created() {
			this.loadinfos();
		}
	};
</script>

<style>
	.demo-spin-icon-load {
		font-size: 5em;
		animation: ani-demo-spin 1s linear infinite;
	}
</style>
